import { TFunction } from 'i18next'
import { TableStructure } from '../../general/table/table-structure.type'
import { formatDateTime } from '../../../utils/date-utils'
import { removeMunicipality } from '../../../utils/cadastre-utils'
import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { SortDirection } from '../../general/models/sort-direction'
import { Paper } from '@mui/material'
import { KotiTable } from '../../general/table/koti-table'
import { useLazyGetAllOrdersQuery } from '../../orders/orders.service'
import { OrderFilters } from '../../orders/order.slice'
import { OrderReportItem } from '../../orders/models/order-report-item.type'
import { AdminOrdersOverview } from '../../orders/components/admin-orders-overview'

const getRealtorOrdersTableStructure = (t: TFunction): TableStructure<OrderReportItem>[] => [
    {
        label: t('TEXT_DATE', 'Dato'),
        columnName: 'created',
        sortFunction: (object) => object.created.getTime(),
        value: (object) => formatDateTime(object.created),
    },
    {
        label: t('TEXT_REALTOR_NAME', 'Meglernavn'),
        columnName: 'userName',
        sortFunction: (object) => object.userName,
        value: (object) => object.userName,
    },
    {
        label: t('TEXT_REALTOR_COMPANY', 'Meglerkontor'),
        columnName: 'contextName',
        sortFunction: (object) => object.companyName,
        value: (object) => object.companyName,
    },
    {
        label: t('TEXT_ORG_NR', 'Org nr'),
        columnName: 'orgNr',
        sortFunction: (object) => object.organizationNr,
        value: (object) => object.organizationNr,
    },

    {
        label: t('TEXT_CADASTRE_NR', 'Matrikkelnr.'),
        columnName: 'cadastreNr',
        sortFunction: (object) => removeMunicipality(object.item.cadastreNr),
        value: (object) => removeMunicipality(object.item.cadastreNr),
    },
    {
        label: t('TEXT_STATUS'),
        sortFunction: (object) => object.item.status,
        value: (object) => t(`ORDER_ITEM_STATUS_${object.item.status}`),
    },
    {
        label: t('TEXT_PROJECT_NR', 'Oppdragsnr.'),
        value: (object) => object.item.note,
    },
]
export const RealtorReportTable: React.FC<{ filters: OrderFilters }> = ({ filters }) => {
    const { t } = useTranslation()
    const [pageNumber, setPageNumber] = useState(0)
    const [itemsPerPage, setItemsPerPage] = useState(10)
    const [sortBy, setSortBy] = useState('created')
    const [direction, setDirection] = useState<SortDirection>('desc')

    const handleOnSortChange = (orderBy: string, order: SortDirection) => {
        setSortBy(orderBy)
        setDirection(order)
    }

    const [trigger, { data }] = useLazyGetAllOrdersQuery()
    const onSubmit = () => trigger({ page: pageNumber, itemsPerPage: itemsPerPage, sortBy, direction, ...filters })
    useEffect(() => {
        onSubmit()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])
    useEffect(() => {
        trigger({ page: pageNumber, itemsPerPage: itemsPerPage, sortBy, direction, ...filters })
    }, [pageNumber, itemsPerPage, direction, trigger, sortBy, filters])
    if (!data || !data.data) {
        return null
    }
    return (
        <Paper elevation={0}>
            <AdminOrdersOverview filters={filters} />
            <KotiTable
                pagination={true}
                sortable={false}
                selectable={false}
                tableStructure={getRealtorOrdersTableStructure(t)}
                rowsPerPage={itemsPerPage}
                page={pageNumber}
                rows={data?.data}
                total={data?.total ?? 0}
                onSortChanged={handleOnSortChange}
                handleChangePage={setPageNumber}
                handleChangeRowsPerPage={setItemsPerPage}
            />
        </Paper>
    )
}
